import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormFieldComponent } from '../form-field.component.js';
import { IconType } from 'lib/ui/icons/index.js';

@Component({
    selector: 'ui-icon-selection-form-field',
    templateUrl: './icon-selection-form-field.component.html',
    styleUrls: ['../form-fields.shared.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IconSelectionFormFieldComponent extends FormFieldComponent<string> {
	public readonly availableIconTypes = input<IconType[]>();

	constructor() {
		super();
	}

	handleSelectIcon(iconType: IconType): void {
		super.updateValue(iconType);
	}

	protected getHint(value?: string): string | undefined {
		return undefined;
	}

	protected isValueValid(value?: string): boolean {
		return true;
	}
}
